import rakePointService from '@/services/rakePointService';
import { buildRakePointNameMap } from '@/lib/tripRouteUtils';

let rakePointNameById = {};
let loadPromise = null;

export const getRakePointNameMap = async () => {
  if (Object.keys(rakePointNameById).length > 0) {
    return rakePointNameById;
  }

  if (!loadPromise) {
    loadPromise = (async () => {
      try {
        const [allPoints, godownPoints, unloadingPoints] = await Promise.all([
          rakePointService.getRakePointsDropdown().catch(() => []),
          rakePointService.getRakePointsDropdown('GODOWN').catch(() => []),
          rakePointService.getRakePointsDropdown('UNLOADING_POINT').catch(() => []),
        ]);

        rakePointNameById = buildRakePointNameMap([
          ...(allPoints || []),
          ...(godownPoints || []),
          ...(unloadingPoints || []),
        ]);
      } catch {
        rakePointNameById = {};
      }

      return rakePointNameById;
    })();
  }

  return loadPromise;
};

export const clearRakePointNameMapCache = () => {
  rakePointNameById = {};
  loadPromise = null;
};
